import styled from 'styled-components';
// superstar background image https://gos3.ibcdn.com/goTribeHomesuperstarbg-1600261442.png
// star background image https://gos3.ibcdn.com/goTribeHomestarBg-1600258066.png
export const GoTribe = styled.section(
    props =>`
    background-image: url(${props.backgroundImage});
    background-repeat: no-repeat;
    background-color: ${props.backgroundColor || 'white'};
    display: flex;
    flex-direction: row;
    border-radius: 10px;
    width: 590px;
    align-items: center;
    height: 190px;
    overflow: hidden;
    border-color:${props.borderColor};
    color:${props.color};
    img {
        border: 0
    }
`
)
export const CardContent = styled.div`
    width: 65%;
`
export const imageWrap = styled.div`
    width: 35%;
    display: flex;
    justify-content: center;
    align-items: center;
`
export const IconWrap = styled.span`
    width: 3.5rem;
`
export const CardTitle = styled.p(
    props=>`
        font-family: ${props.theme.font.fontFamily};
        color: #4f525a;
        font-size: 2.4rem;
        text-transform: uppercase;
        padding-bottom: 1.5rem;
    `
);
export const Text = styled.span(
  props => `
    font-size: 1.6rem;
    color: #1f232e;
`,
);

export const ImgTxt = styled.div`
    display: flex;
    flex-direction: row;
    padding-bottom: 0.8rem;
`
export const Link = styled.a`
    color: #2276e3;
    font-size: 1.2rem;
    font-weight: bold;
    padding:0.5rem 0;
`

export const GoTribe9 = styled.section(
    props =>`
    background-image: url(${props.backgroundImage});
    background-repeat: no-repeat;
    background-color: ${props.backgroundColor || 'white'};
    display: flex;
    flex-direction: row;
    border-radius: 10px;
    width: 100%;
    max-width: 892px;
    align-items: center;
    height: 13rem;
    overflow: hidden;
    border-color:${props.borderColor};
    color:${props.color};
    img {
        border: 0
    }
`
)
export const CardContent9 = styled.div`
    width: 50%;
`
export const imageWrap9 = styled.div`
    width: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
`
export const CardTitle9 = styled.p(
    props=>`
        font-family: ${props.theme.font.fontFamily};
        color: #4f525a;
        font-size: 2.4rem;
        padding-bottom: 1.5rem;
        font-weight: bold;
        span {
            color: #eb6125
        }
    `
);
export const Text9 = styled.p(
  props => `
    font-size: 1.6rem;
    color: #1f232e;
    line-height: 2.5rem;
`,
);

